import { apiUri } from '@/constants/Constants';
import { DealsDashboardClient } from '@/shared/api';

import type {
  UpdateRenewalOpportunitiesRequest,
  UpdateRenewalOpportunitiesResponse,
  UpdateRenewalOpportunityResult,
} from './renewal.types';

/**
 * PATCH /v1/renewal-opportunities — batch save of renewal-intent answers (DDS). Returns the per-item
 * results[] (updated/failed) so the caller can branch on partial failure, not just the HTTP status.
 */
export const updateRenewalOpportunities = async (
  request: UpdateRenewalOpportunitiesRequest,
): Promise<UpdateRenewalOpportunityResult[]> => {
  const { data } = await DealsDashboardClient.patch<UpdateRenewalOpportunitiesResponse>(
    apiUri.updateRenewalOpportunities,
    request,
  );
  return data.data.results;
};
